import React from 'react';
import { Typography, Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { toast } from '@livable/saas-react-components';
import { BackdropLoader } from '@livable/saas-react-components';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
export const BatchDueReminderModalContent = observer(_ref => {
  let handleModalClose = _ref.handleModalClose,
    exportedData = _ref.exportedData;
  const store = useStore();
  const classes = useStyles();
  const modalFooterClasses = useModalFooterStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleSubmit = async () => {
    const data = {
      data: []
    };
    if (exportedData) {
      exportedData.map(i => {
        data.data.push(i.accountId);
      });
    } else {
      store.residenciesMultiActionStore.selectedDetails.map(i => {
        data.data.push(i.accountId);
      });
    }
    const resp = await store.payment.sendBalanceRemainderToMultipleAccountsAsync.run(data);
    if (resp && resp.isSuccessful) {
      toast('success', {
        body: ['Successfully sent']
      });
      if (!exportedData) {
        var _store$homeDashboardS, _store$homeDashboardS2;
        store.residencies.toggleRefreshFlag(true);
        (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.companyResidentsTabOptions) === null || _store$homeDashboardS === void 0 || _store$homeDashboardS.updateModel({
          refreshResidentsFlag: !((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS2 !== void 0 && (_store$homeDashboardS2 = _store$homeDashboardS2.companyResidentsTabOptions) !== null && _store$homeDashboardS2 !== void 0 && _store$homeDashboardS2.refreshResidentsFlag)
        });
        store.residenciesMultiActionStore.deselectAll();
      }
      handleModalClose();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.noPaddingTable
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small",
    variant: "modal"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "light"
  }, "Balance reminder will be sent on residents email. Please pay attention that residents without emails would not receive a reminder.")), /*#__PURE__*/React.createElement("div", null, !exportedData && store.residenciesMultiActionStore.selectedDetails.map(i => {
    var _store$homeDashboardS3;
    return /*#__PURE__*/React.createElement("div", {
      key: i.id,
      className: classes.unit
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      className: "".concat(i.isEmail ? '' : classes.noEmail)
    }, "Unit: ", i.number, ' ', /*#__PURE__*/React.createElement("span", null, ' ', "- ", i.name, i.isEmail ? '' : ' (no email)', store.residenciesMultiActionStore.isSelectedIsMultiPropertyView && !store.residenciesMultiActionStore.isSelectedFromSingleProperty && /*#__PURE__*/React.createElement("span", null, ' ', "- (", (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.propertyDetails(i.propertyId).propertyInformation) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.address) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.addressString, ")"))));
  }), !!exportedData && exportedData.map(i => /*#__PURE__*/React.createElement("div", {
    key: i.propertyId,
    className: classes.unit
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: "".concat(i.emailAddress ? '' : classes.noEmail)
  }, "Unit: ", i.unitName, ' ', /*#__PURE__*/React.createElement("span", null, ' ', "- ", i.residentFullName, i.emailAddress ? '' : ' (no email)')))))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '468-batch-due-reminder-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    onClick: handleSubmit,
    disabled: !exportedData && store.residenciesMultiActionStore.selectedDetails.findIndex(i => !!i.isEmail) === -1 || !!exportedData && exportedData.findIndex(i => !!i.emailAddress) === -1,
    'custom-attribute': '469-batch-due-reminder-modal'
  }, t('buttons.submit')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.sendBalanceRemainderToMultipleAccountsAsync.inProgress
  }));
});